/* Die vier Stufen zwischen Sitzung und Warenkorb.

   Shopify misst Sitzung, Warenkorb, Kasse und Zahlung. Alles dazwischen
   — Fragebogen, Konfigurator, Entwurf geaendert — war bisher nirgends
   gespeichert. Ohne diese Ereignisse laesst sich nicht sagen, ob die
   Besucher am Fragebogen scheitern, am Konfigurator oder am Preis.

   Gezaehlt wird je Sitzung einmal. Wer den Konfigurator fuenfmal
   oeffnet, ist ein Besucher, der ihn geoeffnet hat, nicht fuenf. Dafuer
   liegt je Ereignis eine Marke im sessionStorage.

   Die Sitzungskennung landet zusaetzlich als Attribut im Warenkorb.
   Nur darueber laesst sich spaeter sagen, aus welcher Sitzung eine
   Bestellung entstand — Shopify traegt das Attribut bis in die
   Bestellung. Das passiert erst nach Einwilligung; siehe unten. */

(function () {
  'use strict';

  /* Eigene Geraete (?intern=1, siehe snippets/fp-intern.liquid) melden nichts. */
  if (window.fpIntern) return;

  /* Dieselben Haken wie im Fenster nach den vier Fragen. Der
     Konfigurator hat zwei Oberflaechen: am Schreibtisch Gruppen
     untereinander, auf dem Handy ein Karussell. Die Huelle
     .tda-customizer-customization-option fehlt mobil, die Einzelwerte
     tragen ihre Klasse in beiden. Deshalb haengt alles an den Werten. */
  var ATC = '.tda-customizer-footer-atc-btn';
  var WERT = '.tda-customizer-customization-option-value';

  var FRIST = 30000;      /* so lange wird auf den Konfigurator gewartet */
  var TAKT = 250;

  /* Wohin die Ereignisse zusaetzlich gehen. Steht im Script-Tag im
     Layout, damit die Adresse sichtbar ist und nicht in einer
     Asset-Datei vergraben. Fehlt sie, meldet die Seite nur an Clarity
     weiter wie bisher. */
  var ZIEL = '';
  try {
    var skript = document.currentScript;
    if (skript) ZIEL = skript.getAttribute('data-ereignis') || '';
  } catch (e) {}

  /* ---------------- Sitzung ---------------- */

  function lesen(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function schreiben(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function sitzung() {
    var s = lesen('fp_sid');
    if (s) return s;
    s = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    schreiben('fp_sid', s);
    return s;
  }

  /* Einmal je Sitzung. Gibt true zurueck, wenn es das erste Mal ist. */
  function einmal(name) {
    var k = 'fp_ev_' + name;
    if (lesen(k)) return false;
    schreiben(k, '1');
    return true;
  }

  function melde(name, zusatz) {
    if (!einmal(name)) return;
    if (window.fpClarity && typeof window.fpClarity.track === 'function') {
      window.fpClarity.track(name, zusatz);
    }
    eigenesZiel(name, zusatz);
  }

  /* ---------------- Zweiter Empfaenger ----------------

     Dieselben vier Ereignisse gehen zusaetzlich an unsere eigene
     Schnittstelle. Clarity zeigt sie nur im eigenen Fenster und haelt
     sie dreissig Tage; hier liegen sie in eurem Speicherkonto und
     lassen sich jederzeit auswerten.

     Es gilt dieselbe Schranke wie beim Warenkorb-Attribut: ohne
     Einwilligung in die Statistik geht nichts raus. Ereignisse, die
     vor der Entscheidung entstehen, warten in einer Schlange. Faellt
     die Entscheidung gegen uns aus, wird die Schlange nie geleert und
     verfaellt mit dem Tab.

     Gesendet wird als text/plain. Das ist eine einfache Anfrage, der
     Browser spart sich die Vorabfrage, und der Besucher wartet nicht
     auf eine Statistik. */

  var erlaubt = false;
  var schlange = [];

  function senden(e) {
    if (!ZIEL) return;
    try {
      window.fetch(ZIEL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(e),
        keepalive: true
      }).catch(function () {});
    } catch (e2) {}
  }

  function eigenesZiel(name, zusatz) {
    var e = {
      name: name,
      sid: sitzung(),
      pfad: String(window.location.pathname).slice(0, 120),
      zusatz: zusatz || null
    };
    if (erlaubt) { senden(e); return; }
    if (schlange.length < 20) schlange.push(e);
  }

  function freigeben() {
    if (erlaubt) return;
    erlaubt = true;
    var q = schlange;
    schlange = [];
    for (var i = 0; i < q.length; i++) senden(q[i]);
  }

  /* ---------------- Warenkorb-Attribut ----------------

     Eine Kennung fuer Statistik braucht nach Paragraf 25 TTDSG eine
     Einwilligung. Pandectes meldet den Stand als Bitmaske; ein
     gesetztes Bit heisst abgelehnt, Bit 2 ist die Statistik-Kategorie.
     Ohne Meldung wird nichts geschrieben: lieber eine Luecke in der
     Auswertung als eine Kennung, die niemand erlaubt hat. */

  var attributGesetzt = false;

  function attributSchreiben() {
    if (attributGesetzt) return;
    if (lesen('fp_sid_cart')) { attributGesetzt = true; return; }
    attributGesetzt = true;

    var daten = { attributes: {} };
    daten.attributes['fp_sid'] = sitzung();

    window.fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(daten)
    }).then(function (r) {
      if (r.ok) schreiben('fp_sid_cart', '1');
    }).catch(function () {
      /* Kein Warenkorb, kein Netz, kein Problem: die Ereignisse
         laufen weiter, nur die Verknuepfung zur Bestellung fehlt. */
      attributGesetzt = false;
    });
  }

  window.addEventListener('PandectesEvent_OnConsent', function (e) {
    var p = e && e.detail ? e.detail.preferences : null;
    if (p === null || typeof p === 'undefined') return;
    if ((p & 2) === 0) {
      attributSchreiben();
      freigeben();
    }
  });

  /* Pandectes meldet eine schon gespeicherte Entscheidung gleich beim
     Laden, oft bevor dieses Skript (defer) zuhoert. Wer frueher
     zugestimmt hat, wurde deshalb nie erfasst. Also lesen wir die
     gespeicherte Entscheidung zusaetzlich selbst aus dem Cookie, das
     Pandectes dafuer anlegt: Base64, darin JSON mit preferences. */
  function gespeichert() {
    try {
      var roh = (document.cookie.match(/(?:^|; )_pandectes_gdpr=([^;]+)/) || [])[1];
      if (!roh) return null;
      var d = JSON.parse(window.atob(decodeURIComponent(roh).split(';')[0]));
      return d && typeof d.preferences === 'number' ? d.preferences : null;
    } catch (e) { return null; }
  }

  (function schonEntschieden() {
    var p = gespeichert();
    if (p !== null && (p & 2) === 0) {
      attributSchreiben();
      freigeben();
    }
  })();

  /* ---------------- 1. Fragebogen beendet ----------------

     Der Fragebogen schickt den Besucher mit ?fpIntro=<entwurf> auf die
     Produktseite. Das ist sein Abschluss — ein eigenes Ereignis dafuer
     gibt es im Fragebogen nicht, und diesen Umweg kennt er sicher. */

  function fragebogen() {
    var p;
    try { p = new URLSearchParams(window.location.search).get('fpIntro'); }
    catch (e) { return; }
    if (!p) return;
    melde('questionnaire_completed', { design: String(p).slice(0, 40) });
  }

  /* ---------------- 2. Fenster nach dem Fragebogen ---------------- */

  function fenster() {
    var w = document.querySelector('[data-fp-intro]');
    if (!w) return;
    var sichtbar = function () { return !w.hidden && !!(w.offsetWidth || w.offsetHeight); };
    if (sichtbar()) { melde('design_intro_shown'); return; }

    var b = new MutationObserver(function () {
      if (sichtbar()) { melde('design_intro_shown'); b.disconnect(); }
    });
    b.observe(w, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    window.setTimeout(function () { b.disconnect(); }, FRIST);
  }

  /* ---------------- 3. Konfigurator offen ----------------

     Bereit heisst: der Kaufknopf des Plugins hat eine Flaeche. Vorher
     steht er im Markup, ist aber nicht zu sehen. */

  function konfigurator() {
    if (!document.querySelector('[data-fp-intro]') &&
        !document.querySelector(ATC) &&
        !/\/products\//.test(window.location.pathname)) return;

    var start = Date.now();
    var t = window.setInterval(function () {
      var b = document.querySelector(ATC);
      if (b && (b.offsetWidth || b.offsetHeight)) {
        window.clearInterval(t);
        melde('configurator_opened', { ladezeit_ms: Date.now() - start });
        optionen();
        return;
      }
      if (Date.now() - start > FRIST) window.clearInterval(t);
    }, TAKT);
  }

  /* ---------------- 4. Entwurf geaendert ----------------

     Der erste Klick auf einen Optionswert. Danach wird nicht weiter
     gezaehlt: die Frage ist, ob jemand den Konfigurator benutzt, nicht
     wie oft. */

  function optionen() {
    if (lesen('fp_ev_configurator_changed')) return;
    var auf = function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(WERT)) return;
      document.removeEventListener('click', auf, true);
      melde('configurator_changed');
      attributSchreiben();   /* ab hier lohnt die Verknuepfung */
    };
    document.addEventListener('click', auf, true);
  }

  /* ---------------- Start ---------------- */

  function los() {
    sitzung();
    fragebogen();
    fenster();
    konfigurator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los, { once: true });
  } else {
    los();
  }
})();
